/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        "key": "name",
        "name": "页面名称",
        "type": "text",
        "memo": "页面名称最多30个字",
        "max": 30,
        "required": true
    },
    {
        "key": "background_type",
        "name": "页面背景",
        "type": "page-background",
        "radio-list": [{
            "label": "无",
            "value": 0
        }, {
            "label": "颜色",
            "value": 1
        }]
    },
    {
        "key": "app_type",
        "name": "APP类型",
        "type": "select",
        "memo": "请选择APP类型",
        "option-list": [{
            "label": "卖家版APP",
            "value": "seller"
        }, {
            "label": "买家版APP",
            "value": "buyer"
        }],
        "required": true
    },
    {
        "key": "page_link_type",
        "name": "页面跳转类型",
        "type": "select",
        "memo": "请选择页面跳转类型",
        "option-list": [{
            "label": "商品详情",
            "value": "detail"
        }, {
            "label": "领样详情",
            "value": "promotion"
        }],
        "required": true
    },
    {
        "key": "description",
        "name": "页面描述",
        "type": "text",
        "memo": "页面名称最多100个字",
        "max": 100,
    },
    {
        "key": "share_image",
        "name": "页面分享图片",
        "type": "img",
        "memo": "建议尺寸为 300 * 300",
    },
];
export default config